export default {
  common: {
    nav: {
      home: "முகப்பு",
      find_offer_help: "உதவி தேடு / வழங்கு",
      celebrate: "வாழ்க்கையைக் கொண்டாடு",
      family_tree: "குடும்ப மரம்",
      events: "நிகழ்வுகள்",
      civic_reports: "குடிமை அறிக்கைகள்",
      neighborhood_pulse: "அக்கம்பக்க துடிப்பு",
      weather: "வானிலை",
      nature: "இயற்கை",
      marketplace: "சந்தை",
      news: "செய்திகள்",
      causes: "நோக்கங்கள்",
      more: "மேலும்",
    },
    header: { sign_in: "உள்நுழை", join: "Social Pulse-ல் இணையவும்", language: "மொழி", search: "தேடு" },
    tagline: "சமூகங்களை இணைத்தல் · வாழ்க்கையை மேம்படுத்துதல் · சமூக மூலதனத்தை உருவாக்குதல்",
    locality: {
      viewing_from: "நீங்கள் பார்க்கிறீர்கள்",
      help_improve: "உங்கள் இருப்பிடத்தை மேம்படுத்த உதவுங்கள்",
      filter_by_country: "நாட்டின்படி வடிகட்டு",
      change: "மாற்று",
      set_your_location: "உங்கள் இருப்பிடத்தை அமை",
      set_your_location_hint: "— தனிப்பயனாக்க தட்டவும்",
    },
    actions: {
      submit_cause: "ஒரு நோக்கம் / விண்ணப்பம் சமர்ப்பிக்கவும்",
      make_donation: "Social Pulse-இன் உலகளாவிய முயற்சிகளை ஆதரிக்கவும் — நன்கொடை வழங்கவும்",
      browse_all: "அனைத்து பிரிவுகளையும் பார்க்க",
    },
    news: {
      title: "உங்கள் தினசரி சுருக்கம்.",
      submit_news: "செய்தி சமர்ப்பிக்க",
      archive: "காப்பகம்",
      weather_nature: "வானிலை & இயற்கை",
      play_briefing: "தினசரி சுருக்கத்தைக் கேளுங்கள்",
      play_briefing_hint: "முதன்மையான {{count}} செய்திகளைக் கேளுங்கள் · ~{{minutes}} நிமிடம் · உங்கள் மொழியில்",
      read_original: "மூலத்தைப் படிக்கவும்",
      view_brief: "சுருக்கம் காண்க",
      also_reported_by: "இவர்களாலும் அறிக்கை:",
      translate: "மொழிபெயர்",
      listen: "கேளுங்கள்",
      stop: "நிறுத்து",
    },
  },
};
